import type { FC } from 'react'
import type { TickFilter } from '@g4g/utils/src/types'
import MobileFilters from './MobileFilters'
import MobileSort from './MobileSort'

const MobileDealsHeader: FC<{ category: TickFilter[]; resource: TickFilter[] }> = ({
  category,
  resource,
}) => (
  <>
    <MobileFilters category={category} resource={resource} />
    <MobileSort />
  </>
)

export default MobileDealsHeader
